










import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import confirm from 'components/modals/Confirm'
import api from 'src/assets/api/gql'
import ForumTopicRemove from 'src/graphql/forum/ForumTopicRemove.gql'
import { ForumTopic } from 'src/graphql/types'

@Component
export default class ForumTopicButtonRemove extends Vue {

  @Prop()
  readonly topic!: ForumTopic

  async remove () {
    await confirm({
      title: this.$t('trash.confirmitem').toString(),
      message: this.topic.name
    })
    const { data: { updateForumTopic } } = await api.mutate({
      query: ForumTopicRemove,
      variables: {
        id: this.topic.id
      }
    })
    this.$emit('remove')
  }
}
